import React from 'react';

class ResumeSinceRow extends React.Component {

    constructor(props) {
        super();
    }

    render() {

        let years = (new Date()).getFullYear() - this.props.data.since;
        let currMonth = (new Date()).getMonth();
        if(years == 0) { years = 1}
        if(years < 5 && currMonth > 3) { years = years + "+"}
        if(years > 15) { years = 15 + "+" }

        return (
            <section style={this.props.currStyles.Body.SinceSubSection.Row}>
                <span style={this.props.currStyles.Body.SinceSubSection.Row.Name.Data}>{this.props.data.name}</span>
                <span style={this.props.currStyles.Body.SinceSubSection.Row.Years.Data}>{years}</span>
            </section>
        );
    }
}

export default ResumeSinceRow


// WEBPACK FOOTER //
// src/ResumeAndDocs/ResumeSinceRow.js